import React, { useState, useEffect } from 'react';

import { TrackingEventNames } from 'common/constants/trackingEventsNames';
import eventEmitter from 'common/services/events/eventEmitter';
import trans from 'common/tools/translations/trans';

import NewsletterForm from './form-newsletter';
import NewsletterSubscribedMsg from './modal-newsletter-subscribed';

type Props = {
  campaignId: number;
  infoMsg?: string;
  subscribedMsg?: string;
  title?: string;
  trackingSubject?: string;
};

const NewsletterModule = ({
  campaignId,
  infoMsg,
  subscribedMsg,
  title = 'Subscribe',
  trackingSubject
}: Props) => {
  const [submitSuccess, setSubmitSuccess] = useState(false);

  const baseNewletterTracking = {
    eventAction: 'native',
    subject: trackingSubject
  };

  useEffect(() => {
    eventEmitter.emit(TrackingEventNames.NEWSLETTER_PUSH, {
      eventLabel: 'impression',
      ...baseNewletterTracking
    });
  }, []);

  const _title = submitSuccess
    ? trans('newsletter-modal.subscribed-title')
    : title;

  return submitSuccess ? (
    <NewsletterSubscribedMsg msg={subscribedMsg} title={_title} />
  ) : (
    <NewsletterForm
      campaignId={campaignId}
      infoMsg={infoMsg ?? ''}
      onSubmitSuccess={() => {
        setSubmitSuccess(true);
        eventEmitter.emit(TrackingEventNames.NEWSLETTER_PUSH, {
          eventLabel: 'clic',
          ...baseNewletterTracking
        });
      }}
      title={_title}
    />
  );
};

export default NewsletterModule;
